// #region imports
import React, {  Component }      from 'react';
import PropTypes        from 'prop-types';
import cx               from 'classnames';
import { Link }         from 'react-router-dom';
import auth                   from '../../../../../../services/auth';
import { withRouter }           from 'react-router';

class ViewLink extends Component {
  constructor(props){
    super(props);

  }
  static propTypes = {
    isActive:   PropTypes.bool,
    viewName:   PropTypes.string.isRequired,
    linkTo:     PropTypes.string.isRequired,
    faIconName: PropTypes.string.isRequired,
    itemCount:  PropTypes.number
  };

  static defaultProps = {
    isActive: false
  };

  onHandleChanged(linkKey) {
    const userinfo = auth.getUserInfo();
    let userTypeName = localStorage.getItem("userTypeName");
  }

  render() {
    const { isActive, linkTo, linkKey, viewName, itemCount, faIconName } = this.props;

    return (
        <Link className="btn" to={linkTo} onClick={this.onHandleChanged.bind(this, linkKey)} replace>
          <i className={`fa pull-left ${faIconName}`} style={{lineHeight: '18px'}} />
            <span  className="sidebar-menu__group-title" style={{fontSize: '13px',marginLeft: '5px'}}>
              {viewName}
            </span>
            {itemCount > 0 &&
              <span className="label label-primary pull-right">
                {itemCount}
              </span>
            }
        </Link>
      );
  }

}

export default (withRouter)(ViewLink);


// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/menuLinks/viewLink/ViewLink.js